class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  triggerClick(event) {
    const summary = event.target.querySelector('summary');
    if (!summary || event.target.hasAttribute('open')) return;

    summary.click();
    this.content.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.overlay = this.querySelector('.overlay');
    this.mainDetailsToggle.addEventListener('mouseenter', this.triggerClick.bind(this));
    if (this.overlay) this.overlay.addEventListener('mouseenter', this.close.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  triggerClick(event) {
    const summary = event.target.querySelector('summary');
    if (!summary || event.target.hasAttribute('open')) return;

    document.querySelectorAll('header-menu').forEach(menu => {
      if (menu !== this) menu.close();
    });
    summary.click();
    this.content.focus();
  }
}

customElements.define('header-menu', HeaderMenu);

(() => {
  const firstChildLinks = document.querySelectorAll('.header-wrapper .list-menu--inline > li > a.header__menu-item.list-menu__item');
  if (firstChildLinks.length) {
    firstChildLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        if (document.activeElement.id.includes('MegaMenu')) {
          document.activeElement.blur();
        }
      });
    });
  }
})();